import { useMutation } from '@tanstack/react-query';

import { PluginRunIndividualPlugin } from '../../../../types/plugins';
import { handleError, handleSuccess } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../logic';
import { runIndividualPlugin } from '../../requests/runIndividualPlugin';

export type UseRunIndividualPluginOptions = {
  pluginKey: string;
  successMessage: string;
  errorMessage: string;
};

export const useRunIndividualPlugin = ({
  pluginKey,
  successMessage,
  errorMessage,
}: UseRunIndividualPluginOptions) => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (data: PluginRunIndividualPlugin) =>
      runIndividualPlugin(constructPost, pluginKey, data),
    // These plugins queue their work, so success means the check started, not that a result exists.
    onSuccess: () => handleSuccess(successMessage),
    // The API names what stops an individual being checked, such as missing identification.
    onError: (error: unknown) =>
      handleError(getApiErrorMessage(error, errorMessage)),
  });

  return {
    runIndividualPlugin: mutateAsync,
    ...rest,
  };
};
